import SolidService from '@/services/solidfi/solid.service';
export const solidRequest = new SolidService()